import { atom } from 'jotai'
import { HelperState } from 'sierra-client/views/course-helper/types'

export const helperStateAtom = atom<HelperState>({ type: 'none' })

export const helperCollapsedAtom = atom<boolean>(false)
